import script from "./AppVideoEmbed.vue?vue&type=script&setup=true&lang=js"
export * from "./AppVideoEmbed.vue?vue&type=script&setup=true&lang=js"

import "./AppVideoEmbed.vue?vue&type=style&index=0&id=394193f7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-394193f7"]])

export default __exports__